import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-state", "data-collapsible"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TooltipProvider"], { "delay-duration": 0 }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                class: "group flex h-full flex-col",
                "data-state": $props.rail ? 'collapsed' : 'expanded',
                "data-collapsible": $props.rail ? 'icon' : ''
            }, [
                _createVNode($setup["SidebarContent"], { class: "w-full px-0 overflow-visible" }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3 /* FORWARDED */
                })
            ], 8 /* PROPS */, _hoisted_1)
        ]),
        _: 3 /* FORWARDED */
    }));
}
